import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { ApplicationInvitationList } from 'types/api'
import { BaseResponse } from 'types/utils'

export const invitationsQueryKey = ['invitations']

export function useInvitations() {
  async function getInvitations() {
    const response = await apiClient.get<
      BaseResponse<ApplicationInvitationList>
    >(`${SNA_PREFIX}invitations/`)
    return response.data
  }

  return useQuery({
    queryFn: getInvitations,
    queryKey: invitationsQueryKey
  })
}
